import Vue from "vue";

import CoreImage from "./CoreImage";
import CoreVideo from "./CoreVideo";

const core = [CoreImage, CoreVideo];

core.forEach(component => Vue.component(component.name, component));
